<template>
  <div class="header fixed" :class="{ scrolled: isScrolled }">
    <div class="container header-inner">
      <div class="header-left">
        <div class="logo">
          <router-link to="/">
            <div class="logo-box">
              <img :src="logoBY" width="48" alt="logo" />
              <div class="logo-text-box">
                <span class="logo-text">豹眼背调</span>
                <span class="logo-text-zm">baoyanbd.com</span>
              </div>
            </div>
          </router-link>
        </div>
        <!-- 桌面导航菜单 -->
        <nav class="nav-menu">
          <router-link v-for="item in navItems" :key="item.path" :to="item.path" class="nav-item" active-class="active"
            :exact="item.path === '/'">
            {{ item.label }}
          </router-link>
        </nav>
      </div>
      <div class="user-area">
        <a class="button-container call-button" type="button" href="tel:400-8600-575">
          <span class="icon-container-bg"></span>
          <span class="icon-container">
            <span class="phone">
              <!-- <svg width="15" height="17" viewBox="0 0 15 17">
                <path
                  d="M-37.64-900.53a8.685,8.685,0,0,1-2.75-.7.9.9,0,0,0-1.073.248l-1.746,2.025a14.143,14.143,0,0,1-4.951-5.748l1.744-2.026a1.313,1.313,0,0,0,.214-1.252,12.939,12.939,0,0,1-.6-3.185.815.815,0,0,0-.744-.831h-3.208a1.11,1.11,0,0,0-1,1.212c0,.018,0,.037.007.055.533,8.513,6.389,15.318,13.722,15.936a1.072,1.072,0,0,0,1.093-1.05q0-.049,0-.1v-3.4c0-.8-.314-1.157-.712-1.19"
                  transform="translate(51.757 912)" class="svg-icon" />
              </svg> -->
              <img src="@/assets/images/phone.png" width="24" />
            </span>
          </span>
          <span class="word">400-8600-575</span>
        </a>

        <a href="https://www.baoyanbd.com/admin" target="_blank" class="btn-login">登录</a>
        <a href="https://www.baoyanbd.com/admin/register?inviteSaleId=100" target="_blank" class="btn-register">注册</a>

        <img src="@/assets/images/menu.png" @click="toggleMenu" class="hamburger-btn" :class="{ active: isMenuOpen }" />
      </div>
    </div>

    <!-- 移动端下拉菜单 -->
    <transition name="slide-down">
      <div v-if="isMenuOpen" class="mobile-menu" @click="closeMenu">
        <div class="mobile-menu-inner" @click.stop>
          <router-link v-for="item in navItems" :key="item.path" :to="item.path" class="mobile-nav-item"
            active-class="active" :exact="item.path === '/'" @click="closeMenu">
            {{ item.label }}
          </router-link>
          <!-- <div class="mobile-menu-divider"></div> -->
          <div class="mobile-actions">
            <a href="https://www.baoyanbd.com/admin" target="_blank" class="mobile-btn-login">登录</a>
            <a href="https://www.baoyanbd.com/admin/register?inviteSaleId=100" target="_blank"
              class="mobile-btn-register">注册</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      isScrolled: false,
      isMenuOpen: false,
      logoBY: require('@/assets/images/logo_yun2.png'),
      navItems: [
        { label: '首页', path: '/' },
        { label: '场景使用', path: '/industry' },
        { label: '产品与服务', path: '/service' },
        { label: '关于我们', path: '/about' },
        // { label: '新闻资讯', path: '/news' }
      ],
      scrollPosition: 0
    }
  },
  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    // // 窗口变化时重置菜单状态
    // window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    // window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      // if (this.isMenuOpen) {
      //   this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
      //   document.body.style.overflow = 'hidden'
      //   document.body.style.position = 'fixed'
      //   document.body.style.top = `-${this.scrollPosition}px`
      //   document.body.style.width = '100%'
      // } else {
      //   this.resetBodyScroll()
      // }
    },
    closeMenu() {
      this.isMenuOpen = false
      // this.resetBodyScroll()
    },
    // 抽离统一恢复滚动函数
    resetBodyScroll() {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      // 关键：下一帧再恢复滚动位置，解决移动端时序bug
      this.$nextTick(() => {
        window.scrollTo(0, this.scrollPosition || 0)
      })
    },
    handleResize() {
      if (window.innerWidth > 768 && this.isMenuOpen) {
        this.closeMenu()
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.header {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: background-color 0.3s;

  &.scrolled {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    .nav-item {
      color: #212121;

      &:hover,
      &.active {
        color: #000;
        font-weight: 700;
      }
    }

    .button-container {
      color: #3784ff;
      border-color: #dfe2eb;
    }

    .word {
      color: #3784ff;
    }
  }
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  padding: 0 20px;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  margin-right: 28px;

  img {
    display: block;
    height: auto;
  }
}

.nav-menu {
  display: flex;
  align-items: center;
}

.nav-item {
  padding: 26px 28px 24px;
  font-size: 16px;
  color: #212121;
  letter-spacing: 1px;
  line-height: 22px;
  transition: color 0.3s;
  outline: none;
  text-decoration: none;

  &:focus-visible {
    outline: none;
  }

  &:hover,
  &.active {
    color: #000;
    font-weight: 700;
  }
}

.user-area {
  display: flex;
  align-items: center;
  gap: 10px;
}

.button-container {
  position: relative;
  box-sizing: content-box;
  width: 157px;
  height: 40px;
  padding: 0 5px;
  font-size: 16px;
  line-height: 40px;
  letter-spacing: -0.08px;
  color: #3784ff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 22px;
  background: transparent;
  overflow: hidden;
  outline: none;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:hover {
    border: 1px solid #dfe2eb;
  }
}

.icon-container-bg {
  position: absolute;
  left: 4px;
  top: 50%;
  width: 32px;
  height: 32px;
  border-radius: 20px;
  background-color: #1f5fff;
  transform: translateY(-50%);
  transition: all 0.4s ease;
}

.icon-container {
  position: absolute;
  left: 4px;
  top: 55%;
  width: 32px;
  height: 32px;
  line-height: 22px;
  transform: translateY(-50%);
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-icon {
  fill: #fff;
}

.word {
  margin-left: 44px;
  font-weight: 500;
  color: #3784ff;
  transition: color 0.3s;
}

.logo-box {
  display: flex;
  align-items: center;
  justify-content: center;

  .logo-text-box {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    .logo-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }

    .logo-text-zm {
      font-size: 12px;
      color: #444;
    }
  }
}

.btn-login {
  height: 36px;
  line-height: 34px;
  font-size: 16px;
  padding: 0 22px;
  color: #3784ff;
  border: 1px solid #3784ff;
  transition: all .3s;
  border-radius: 2px !important;
  text-decoration: none;

  &:hover,
  &.active {
    color: #1B60FD;
  }
}

.btn-register {
  height: 36px;
  line-height: 34px;
  font-size: 16px;
  padding: 0 22px;
  color: #fff;
  background-color: #3784ff;
  border: 1px solid #3784ff;
  transition: all .3s;
  border-radius: 2px !important;
  text-decoration: none;

  &:hover,
  &.active {
    color: #fff;
    background-color: #1B60FD;
    border-color: #1B60FD;
  }
}

.hamburger-btn {
  display: none;
  width: 30px;
  height: 30px;
  margin-left: 10px;
}

.mobile-menu {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.mobile-menu-inner {
  background: #fff;
  padding: 20px 24px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  max-height: calc(100vh - 72px);
  overflow-y: auto;
}

.mobile-nav-item {
  display: block;
  padding: 10px 0;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.2s;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &.active {
    color: #3784ff;
    font-weight: 700;
  }
}

.mobile-menu-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 8px 0 16px;
}

.mobile-actions {
  display: flex;
  gap: 12px;
  padding-top: 16px;

  .mobile-btn-login,
  .mobile-btn-register {
    flex: 1;
    text-align: center;
    padding: 8px 0;
    margin: 0 20px;
    border-radius: 6px;
    font-size: 16px;
    text-decoration: none;
    transition: all 0.3s;
  }

  .mobile-btn-login {
    color: #3784ff;
    border: 1px solid #3784ff;
    background: transparent;

    &:hover {
      background: rgba(55, 132, 255, 0.06);
    }
  }

  .mobile-btn-register {
    color: #fff;
    background: #3784ff;
    border: 1px solid #3784ff;

    &:hover {
      background: #1B60FD;
      border-color: #1B60FD;
    }
  }
}

/* 下拉动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: opacity 0.25s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
}

.slide-down-enter-active .mobile-menu-inner,
.slide-down-leave-active .mobile-menu-inner {
  transition: transform 0.25s ease;
}

.slide-down-enter .mobile-menu-inner,
.slide-down-leave-to .mobile-menu-inner {
  transform: translateY(-12px);
}

/* ========== 响应式========== */

@media (max-width: 1200px) {
  .nav-item {
    padding: 26px 16px 24px;
    font-size: 16px;
  }

  .button-container {
    width: 130px;
    font-size: 14px;
  }

  .word {
    margin-left: 38px;
    font-size: 14px;
  }

  .btn-login,
  .btn-register {
    padding: 0 16px;
    font-size: 14px;
  }
}

/* 平板及以下（≤ 992px） */
@media (max-width: 992px) {
  .nav-item {
    padding: 26px 14px 24px;
    font-size: 16px;
  }

  .button-container {
    width: 130px;
    font-size: 14px;
  }

  .word {
    margin-left: 38px;
    font-size: 14px;
  }

  .btn-login,
  .btn-register {
    padding: 0 16px;
    font-size: 14px;
  }

  .button-container {
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 50%;
    border-color: #dfe2eb;
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;

    .word {
      display: none;
    }

    .icon-container-bg {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 28px;
      height: 28px;
    }

    .icon-container {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &:hover {
      border-color: #3784ff;
    }
  }

   .phone {
    width: 24px;
    height: 24px;
  }
}

/* 手机端（≤ 767px） */
@media (max-width: 767px) {
  .header-inner {
    padding: 0 16px;
    height: 60px;
  }

  .nav-menu {
    display: none;
  }

  .btn-login,
  .btn-register {
    display: none;
  }

  .hamburger-btn {
    display: flex;
  }

  .button-container {
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 50%;
    border-color: #dfe2eb;
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;

    .word {
      display: none;
    }

    .icon-container-bg {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 28px;
      height: 28px;
    }

    .icon-container {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &:hover {
      border-color: #3784ff;
    }
  }

  .logo {
    margin-right: 12px;

    img {
      width: 36px !important;
    }
  }

  .logo-box .logo-text-box {
    .logo-text {
      font-size: 15px;
    }

    .logo-text-zm {
      font-size: 10px;
    }
  }

  .user-area {
    gap: 6px;
  }

  .mobile-menu {
    top: 60px;
  }

  .mobile-menu-inner {
    max-height: calc(100vh - 60px);
  }

  .phone {
    width: 24px;
    height: 24px;
  }
}
</style>